import * as React from 'react';
import Button from '../../../shared/form/Button';
import { useFilterContext } from '../FilterContext';
import { IFilterItem } from '../IFilterItem';
import { FilterItem } from './dropdown/FilterItem';
import { Search } from './dropdown/Search';

export function Dropdown({
  focusIndex,
  setFocusIndex,
}: {
  focusIndex: number;
  setFocusIndex: (number: number) => void;
}) {
  const { handleFilterClear, handleFilterClose, items, searchValue, selectedItemValues } = useFilterContext();
  const isSearchVisible = items.length > 5;

  const filteredItems = items.filter((item: IFilterItem) => {
    return item.label.toLowerCase().includes(searchValue.toLowerCase());
  });

  const filterItems = filteredItems.map((item: IFilterItem, index) => {
    const isSelected = selectedItemValues.includes(item.value);
    return <FilterItem key={item.value} {...{ focusIndex, index, item, isSelected, setFocusIndex }} />;
  });

  return (
    <div className="filter__dropdown">
      {isSearchVisible && <Search />}
      <header className="hide-at-sm-block filter__header">
        <div className="frow frow--justify-between">
          <span className="filter__link" onClick={handleFilterClear}>
            Clear
          </span>
          <span onClick={handleFilterClose}>
            <i className="fal fa-times" />
          </span>
        </div>
      </header>
      {filterItems}
      <footer className="hide-at-sm-block filter__footer">
        <Button
          className="external-button external-button--theme-highlight external-button--full"
          handleClick={handleFilterClose}
          text="Apply Filters"
        />
      </footer>
    </div>
  );
}
